import VocTextarea from "./src/main"

/* istanbul ignore next */
VocTextarea.install = function (Vue) {
  Vue.component(VocTextarea.name, VocTextarea)
}

export default VocTextarea
